import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component'; 
import { ChartModule } from 'primeng/chart';
import 'chartjs-plugin-datalabels'; 
import { AppLoadingDirectiveModule } from '@modules/common/loading/loading.directive';
import { RouterModule } from '@angular/router';
import { NgApexchartsModule } from "ng-apexcharts"; 
@NgModule({
  imports: [
    CommonModule,
    ChartModule,
    AppLoadingDirectiveModule,
    RouterModule,
    NgApexchartsModule
  ],
  declarations: [
    HomeComponent
  ],
  entryComponents: [ 
  ]
})
export class HomeModule { }
